var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info-empty"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99996 8.95842C10.3451 8.95842 10.625 9.23824 10.625 9.58342V13.7501C10.625 14.0953 10.3451 14.3751 9.99996 14.3751C9.65478 14.3751 9.37496 14.0953 9.37496 13.7501V9.58342C9.37496 9.23824 9.65478 8.95842 9.99996 8.95842Z",
    fill: "#656579"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4264 5.7846C10.683 6.01551 10.7038 6.41069 10.4729 6.66726L10.4645 6.67652C10.2336 6.93309 9.83842 6.95389 9.58186 6.72297C9.32529 6.49206 9.30449 6.09688 9.5354 5.84031L9.54373 5.83105C9.77465 5.57448 10.1698 5.55369 10.4264 5.7846Z",
    fill: "#656579"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99996 2.29175C5.74276 2.29175 2.29163 5.74289 2.29163 10.0001C2.29163 14.2573 5.74276 17.7084 9.99996 17.7084C14.2572 17.7084 17.7083 14.2573 17.7083 10.0001C17.7083 5.74289 14.2572 2.29175 9.99996 2.29175ZM1.04163 10.0001C1.04163 5.05253 5.05241 1.04175 9.99996 1.04175C14.9475 1.04175 18.9583 5.05253 18.9583 10.0001C18.9583 14.9476 14.9475 18.9584 9.99996 18.9584C5.05241 18.9584 1.04163 14.9476 1.04163 10.0001Z",
    fill: "#656579"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoEmpty);
export default __webpack_public_path__ + "static/media/info-empty.56d62a8015358d117dd4586ce4a86ed0.svg";
export { ForwardRef as ReactComponent };